import React, { useState } from 'react';
import { Spinner, Text, ChoiceGroup } from '@fluentui/react';
import useAxios from 'axios-hooks';
import { useRouteMatch, useHistory } from 'react-router-dom';
import IntegratedRewardsTable from '../Components/IntegratedRewardsTable';
import IntegratedRewardsClientDashboardsTable from '../Components/IntegratedRewardsClientDashboardsTable';
import DeleteModal from "../../../../Util/DeleteModal";
import { useBoolean } from '@fluentui/react-hooks';
import ErrorComponent from '../../../../Util/ErrorComponent';
import SuccessComponent from '../../../../Util/SuccessComponent';

const levelOptions = [
  { key: 0, text: 'client' },
  { key: 1, text: 'cobrand' },
];

const DefaultPage = () => {
    const [selectedItem, setSelectedItem] = useState(undefined);
    const [selectedItemName, setSelectedItemName] = useState("");
    const history = useHistory();
    const [showSuccess, setShowSuccess] = useState(false);
    const [showError, setShowError] = useState(false);
    const [errorMsg, setErrorMsg] = useState('');
    const [level, setLevel] = useState('');
    let { url } = useRouteMatch();
    const [showDeleteModal, { toggle: toggleDeleteModal }] = useBoolean(false);

    const [{ data: items, loading }, refetch] = useAxios("integrated-rewards/dashboard/all?bustCache=true");

    if (loading) return <Spinner className="absolute-center" label="Loading Integrated Rewards..." />;

    return (
        <>
            <SuccessComponent
                successMessage="Integrated Reward Deleted."
                showSuccess={showSuccess}
                setShowSuccess={setShowSuccess}
            />
            <ErrorComponent
                errorMessage={errorMsg}
                showError={showError}
                setShowError={setShowError}
            />
            <ChoiceGroup
                label="Select the dashboard's display level"
                options={levelOptions}
                onChange={(e, x) => {
                    setLevel(x.text);
                    setSelectedItem(undefined);
                    setSelectedItemName("");
                }}
            />
            <Text variant="small">
                {level === '' ? 
                    "Select 'client' or 'cobrand' to see the current custom reward pages."
                    : 
                    `Select an existing ${level} dashboard or create a new one. The integrated rewards page will appear for all ${level} users.`}
            </Text>
            <hr />
            {level === 'client' && 
                <IntegratedRewardsClientDashboardsTable
                    dashboards={items.clients && items.clients.length > 0 ? items.clients.sort((a, b) => b.integratedRewardsClientDashboardId - a.integratedRewardsClientDashboardId) : []}
                    setSelectedItem={setSelectedItem}
                    setSelectedItemName={setSelectedItemName}
                    selectedItem={selectedItem}
                    createOnClick={() => history.push(`${url}/${level}/wizard`)}
                    editOnClick={(id) => history.push(`${url}/${level}/${id}/wizard`)}
                    deleteOnClick={(id, label) => {
                        setSelectedItem(id);
                        setSelectedItemName(label || "");
                        toggleDeleteModal();
                    }}
                    refetch={refetch}
                    loading={loading}
                />
            }
            {level === 'cobrand' && 
                <IntegratedRewardsTable
                    dashboards={items.cobrands && items.cobrands.length > 0 ? items.cobrands.sort((a, b) => b.integratedRewardsDashboardId - a.integratedRewardsDashboardId) : []}
                    setSelectedItem={setSelectedItem}
                    setSelectedItemName={setSelectedItemName}
                    selectedItem={selectedItem}
                    createOnClick={() => history.push(`${url}/${level}/wizard`)}
                    editOnClick={(id) => history.push(`${url}/${level}/${id}/wizard`)}
                    deleteOnClick={(id, label) => {
                        setSelectedItem(id);
                        setSelectedItemName(label || "");
                        toggleDeleteModal();
                    }}
                    refetch={refetch}
                    loading={loading}
                />
            }
            {level && (
            <DeleteModal
                showModal={showDeleteModal}
                toggleShowModal={toggleDeleteModal}
                onDelete={() => refetch()}
                setErrorMsg={setErrorMsg}
                setShowError={setShowError}
                setShowSuccess={setShowSuccess}
                deleteUrl={`integrated-rewards/${level}/dashboard/${selectedItem}/`}
                resourceName={selectedItemName}
                resourceType={`${level} custom dashboard`}
                confirmationValue={selectedItemName || undefined}
            />
            )}
        </>
    );
};

export default DefaultPage;
